import { useContext, useEffect, useRef, useState } from "react";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";

const CalendlyPopupButton = ({
  url,
  text = "Express interest →",
  className,
  onClick,
  triggerPopup = false,
  open: openProp,
  style,
  moduleName,
  onCalendlyOpen,
  onCalendlyDateSelected,
  onCalendlyScheduled,
  onCalendlyDropOff,
}) => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const [isOpen, setIsOpen] = useState(false);
  const hasScheduled = useRef(false);

  useEffect(() => {
    if (openProp !== undefined) setIsOpen(openProp);
  }, [openProp]);

  const track = (definition) => {
    if (moduleName) {
      TrackMixPanel({ ModuleName: moduleName, ScreenName: "LoRRI-Benchmark", Definition: definition });
    }
  };

  useCalendlyEventListener({
    onEventTypeViewed: () => {
      if (isOpen) {
        hasScheduled.current = false;
        track("Calendly modal opened");
        onCalendlyOpen?.();
      }
    },
    onDateAndTimeSelected: () => {
      if (isOpen) {
        track("Calendly date selected");
        onCalendlyDateSelected?.();
      }
    },
    onEventScheduled: (e) => {
      if (isOpen) {
        hasScheduled.current = true;
        track("Calendly meeting scheduled");
        onCalendlyScheduled?.(e);
      }
    },
  });

  const handleClick = (e) => {
    onClick?.(e);
    if (triggerPopup) setIsOpen(true);
  };

  const handleModalClose = () => {
    if (!hasScheduled.current) {
      track("Calendly modal closed without booking");
      onCalendlyDropOff?.();
    }
    hasScheduled.current = false;
    setIsOpen(false);
  };

  return (
    <>
      <button className={className} onClick={handleClick} style={style}>
        {text}
      </button>
      <PopupModal
        url={url}
        onModalClose={handleModalClose}
        open={isOpen}
        rootElement={document.getElementById("root") || document.body}
        prefill={{
          name: userDetails?.user_name || "",
          email: userDetails?.email || "",
        }}
      />
    </>
  );
};

export default CalendlyPopupButton;
